export default "__VITE_ASSET__CgmJiaU2__"